module.exports = __webpack_public_path__ + "f24a84225780c0b13b8141eab2f1bc31.svg";